const addIfNotExists = (userList, user) => {
  if (!user) return
  const exists = userList.findIndex(u => u.id === user.id && u.displayName===user.displayName) > -1
  if (exists) return
  userList.push(user)
}

const trackOcurrences = (ocurrences, userToFind, configName, role, user, entityId, name = '') => {
  if (!user) return
  if (user.id !== userToFind.id || user.displayName !== userToFind.displayName) return
  if (!ocurrences[configName]) ocurrences[configName] = []
  if (ocurrences[configName].findIndex(o => o.user.id === user.id && o.user.displayName === user.displayName && o.role === role && o.entityId === entityId) === -1) {
    ocurrences[configName].push({ user, role, entityId, name })
  }
}

const userReplacementMixins = {
  data() {
    return {
      configurationDisplayNames: {
        changeCategories: 'Change Categories',
        approvalProcessTypes: 'Approval Process Types',
        relationships: 'Responses Relationships',
        communityOwners: 'Community Owner',
        changeCategoryMocTypes: 'Change Category Moc Types',
        tasks: 'Tasks',
        approver: 'Approver',
        fyi: 'FYI',
        owner: 'Owner',
        taskOwner: 'Task Owner',
        facilitator: 'Facilitator',
        facilitatorBackup: 'Facilitator Backup',
        assignee: 'Task Assignee',
        changeTypes: 'Change Types',
        vp: 'Senior Manager',
        lineManager: 'Line Manager'
      }
    }
  },
  methods: {
    getPeopleInCommunity: function(fullCommunity) {
      let peopleWhoCanBeReplaced = []
      ;(fullCommunity.owners || []).forEach(o => addIfNotExists(peopleWhoCanBeReplaced, o))
      ;(fullCommunity.changeCategories || []).forEach(changeCategory => {
        addIfNotExists(peopleWhoCanBeReplaced, changeCategory.facilitator)
        addIfNotExists(peopleWhoCanBeReplaced, changeCategory.backupFacilitator)
        ;(changeCategory.approvalProcessTypes || []).forEach(approvalProcessType => {
          addIfNotExists(peopleWhoCanBeReplaced, approvalProcessType.owner)
          ;(approvalProcessType.approvers || []).forEach(approver => addIfNotExists(peopleWhoCanBeReplaced, approver))
          ;(approvalProcessType.fyis || []).forEach(fyi => addIfNotExists(peopleWhoCanBeReplaced, fyi))

          if (approvalProcessType.multiPass && approvalProcessType.multiPass.approvalPasses) {
            const passes = approvalProcessType.multiPass.approvalPasses
            passes.forEach(pass => {
              ;(pass.additionalApprovers || []).forEach(approver => {
                addIfNotExists(peopleWhoCanBeReplaced, approver)
              })
              ;(pass.approvers || []).forEach(approver => {
                addIfNotExists(peopleWhoCanBeReplaced, approver)
              })
              ;(pass.additionalFyis || []).forEach(fyi => {
                addIfNotExists(peopleWhoCanBeReplaced, fyi)
              })
              ;(pass.fyis || []).forEach(fyi => {
                addIfNotExists(peopleWhoCanBeReplaced, fyi)
              })
            })
          }
        })
        ;(changeCategory.mocTypes || []).forEach(mocType => {
          ;(mocType.approvers || []).forEach(approver => addIfNotExists(peopleWhoCanBeReplaced, approver))
          ;(mocType.fyis || []).forEach(fyi => addIfNotExists(peopleWhoCanBeReplaced, fyi))
        })
      })
      ;(fullCommunity.tasks || []).forEach(t => {
        addIfNotExists(peopleWhoCanBeReplaced, t.assignedTo)
        addIfNotExists(peopleWhoCanBeReplaced, t.owner)
      })
      ;(fullCommunity.qaRelationships || []).forEach(relationship => {
        ;(relationship.approvers || []).forEach(approver => addIfNotExists(peopleWhoCanBeReplaced, approver))
        ;(relationship.fyis || []).forEach(fyi => addIfNotExists(peopleWhoCanBeReplaced, fyi))
      })
      return this.$_.sortBy(peopleWhoCanBeReplaced, ['displayName'])
    },
    findUserInCommunity(fullCommunity, user) {
      let result = {}
      ;(fullCommunity.owners || []).forEach(o => trackOcurrences(result, user, 'communityOwners', 'communityOwners', o))
      ;(fullCommunity.changeCategories || []).forEach(changeCategory => {
        trackOcurrences(
          result,
          user,
          'changeCategories',
          'facilitator',
          changeCategory.facilitator,
          changeCategory.id,
          changeCategory.name
        )
        trackOcurrences(
          result,
          user,
          'changeCategories',
          'facilitatorBackup',
          changeCategory.backupFacilitator,
          changeCategory.id,
          changeCategory.name
        )
        ;(changeCategory.approvalProcessTypes || []).forEach(approvalProcessType => {
          trackOcurrences(
            result,
            user,
            'approvalProcessTypes',
            'owner',
            approvalProcessType.owner,
            approvalProcessType.id,
            approvalProcessType.name
          )
          trackOcurrences(
            result,
            user,
            'approvalProcessTypes',
            'vp',
            approvalProcessType.vp,
            approvalProcessType.id,
            approvalProcessType.name
          )
          trackOcurrences(
            result,
            user,
            'approvalProcessTypes',
            'lineManager',
            approvalProcessType.lineManager,
            approvalProcessType.id,
            approvalProcessType.name
          )
          ;(approvalProcessType.approvers || []).forEach(approver =>
            trackOcurrences(
              result,
              user,
              'approvalProcessTypes',
              'approver',
              approver,
              approvalProcessType.id,
              approvalProcessType.name
            )
          )
          ;(approvalProcessType.fyis || []).forEach(fyi =>
            trackOcurrences(result, user, 'approvalProcessTypes', 'fyi', fyi, approvalProcessType.id, approvalProcessType.name)
          )

          if (approvalProcessType.multiPass && approvalProcessType.multiPass.approvalPasses) {
            const passes = approvalProcessType.multiPass.approvalPasses
            passes.forEach(pass => {
              ;(pass.additionalApprovers || []).forEach(approver => {
                trackOcurrences(
                  result,
                  user,
                  'approvalProcessTypes',
                  'approver',
                  approver,
                  approvalProcessType.id,
                  approvalProcessType.name
                )
              })
              ;(pass.approvers || []).forEach(approver => {
                trackOcurrences(
                  result,
                  user,
                  'approvalProcessTypes',
                  'approver',
                  approver,
                  approvalProcessType.id,
                  approvalProcessType.name
                )
              })
              ;(pass.additionalFyis || []).forEach(approver => {
                trackOcurrences(
                  result,
                  user,
                  'approvalProcessTypes',
                  'fyi',
                  approver,
                  approvalProcessType.id,
                  approvalProcessType.name
                )
              })
              ;(pass.fyis || []).forEach(approver => {
                trackOcurrences(
                  result,
                  user,
                  'approvalProcessTypes',
                  'fyi',
                  approver,
                  approvalProcessType.id,
                  approvalProcessType.name
                )
              })
            })
          }
        })
        ;(changeCategory.mocTypes || []).forEach(mocType => {
          ;(mocType.approvers || []).forEach(approver =>
            trackOcurrences(
              result,
              user,
              'changeCategoryMocTypes',
              'approver',
              approver,
              mocType.id,
              `${changeCategory.name} - ${mocType.value}`
            )
          )
          ;(mocType.fyis || []).forEach(fyi =>
            trackOcurrences(
              result,
              user,
              'changeCategoryMocTypes',
              'fyi',
              fyi,
              mocType.id,
              `${changeCategory.name} - ${mocType.value}`
            )
          )
        })
      })
      ;(fullCommunity.tasks || []).forEach(t => {
        trackOcurrences(result, user, 'tasks', 'assignee', t.assignedTo, t.id, t.name)
        trackOcurrences(result, user, 'tasks', 'taskOwner', t.owner, t.id, t.name)
      })
      ;(fullCommunity.qaRelationships || []).forEach(relationship => {
        ;(relationship.approvers || []).forEach(approver =>
          trackOcurrences(result, user, 'relationships', 'approver', approver, relationship.id)
        )
        ;(relationship.fyis || []).forEach(fyi => trackOcurrences(result, user, 'relationships', 'fyi', fyi, relationship.id))
      })

      return result
    }
  }
}

export default userReplacementMixins
